var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_vm.images.length ? _c('div', {
    staticClass: "swiper"
  }, [_c('m-swiper', {
    attrs: {
      "list": _vm.images,
      "autoplay": false,
      "showIndicator": false,
      "loop": false
    },
    on: {
      "change": _vm.onSwiperChange
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('image-item', {
          attrs: {
            "is-small": false,
            "item": item,
            "imageType": "urlDefault",
            "img-style": {
              height: _vm.convertLrpxToRem(_vm.state.swiperHeight)
            }
          }
        })];
      }
    }], null, false, 2255842614)
  }), _c('div', {
    staticClass: "indicator"
  }, [_vm._v(" " + _vm._s(_vm.state.currentSwiperIdx) + "/" + _vm._s(_vm.images.length) + " ")])], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }